'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';

import styles from './ShowMore.module.scss';

const ShowMore = ({
    className,
    buttonClassName,
    onClick,
    remainingItems,
    text = 'Show More',
    style = 'filled-blue-ocean',
    disabled = false,
    ...rest
}) => {
    const buttonText = remainingItems ? `${text} (${remainingItems})` : text;

    return (
        <div className={cx(styles.root, className)} {...rest}>
            <div className={styles.buttonWrapper}>
                <ButtonCTA
                    className={buttonClassName}
                    text={buttonText}
                    style={style}
                    onClick={onClick}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

ShowMore.propTypes = {
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    remainingItems: PropTypes.number,
    text: PropTypes.string,
    style: PropTypes.string,
    disabled: PropTypes.bool,
};

export default ShowMore;
